import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

// This component redirects to the SSR version for SEO
const CategoryPage = () => {
  const { category } = useParams();

  useEffect(() => {
    // Redirect to SSR page for proper SEO
    window.location.href = `/api/seo/category/${category}`;
  }, [category]);

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-[#bef264] mx-auto mb-4" />
        <p className="text-[#a1a1aa]">Loading category...</p>
      </div>
    </div>
  );
};

export default CategoryPage;
